import React from "react";
import { useNavigate } from "react-router-dom";
import OneProductCard from "./Essentials/OneProductCard/OneProductCard";

const GroupsProductSection = ({ Case,GroupsProductData, selectedMedium }) => {
    const navigate = useNavigate();

    if (!GroupsProductData || GroupsProductData.length === 0) {
        return <div>No products available for this category!</div>;
    }

    const handleClick = (path) => {
        navigate(path);
    };

    if(Case != 3){
        return (
            <>
                {GroupsProductData.map((item, index) => {
                    
                    if (!item.child_products || item.child_products.length === 0) return null;
    
                    const filteredProducts = item.child_products.filter(
                        (product) => product.product_lang === selectedMedium || selectedMedium === ''
                    );
    
                    if (filteredProducts.length === 0) return null;
    
                    return (
                        <div key={index} className="mb-10">
                            <div className="flex justify-between items-center">
                                <h2 className="text-xl font-bold">
                                    {item.category_name_english}
                                </h2>
                                {item.view_all_redirection_end_point && (
                                    <button 
                                        className="text-blue-600 hover:text-blue-500 font-normal rounded-lg transition-all duration-300"
                                        onClick={() => handleClick(item.view_all_redirection_end_point)}
                                    >
                                        View All
                                    </button>
                                )}
                            </div>
    
                            <div
                                className="flex gap-6 overflow-x-auto touch-pan-x scrollbar-hide mt-4"
                                style={{
                                    scrollSnapType: "x mandatory",
                                    WebkitOverflowScrolling: "touch",
                                }}
                            >
                                {filteredProducts.map((product) => (
                                    <OneProductCard key={product.product_id} product={product} />
                                ))}
                            </div>
                        </div>
                    );
                })}
            </>
        );
    }else{
        const filteredProducts = GroupsProductData.filter(
            (product) => product.product_lang === selectedMedium || selectedMedium === ''
        );
        
        if (filteredProducts.length === 0) return (<div>No products available for this category!</div>);

        // console.log('filteredProducts ==> ',filteredProducts);
        return (
            <>
                <div key='one_product_list' className="mb-10">
                    <div
                        // className="flex flex-wrap justify-between items-center gap-y-[30px] flex-row mt-4"
                        className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-4"
                    >
                        {filteredProducts.map((product) => (
                            <OneProductCard key={product.product_id} product={product} />
                        ))}
                    </div>
                </div>
            </>
        );
    }
    
};

export default GroupsProductSection;
